export default __webpack_public_path__ + "c4edf2fe02848da885d5fdb142d2f51f.png";